
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/k/[slug]",
      function () {
        return require("private-next-pages/k/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/k/[slug]"])
      });
    }
  